import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { PagoService } from 'src/app/services/pago.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import * as _ from 'lodash'

@Component({
  selector: 'app-consultar-pagos-proveedor-modal-view-details',
  templateUrl: './modal-view-details.component.html',
  styleUrls: ['../consultar-pagos-proveedores.component.scss'],
  providers: [SecurityService]
})
export class ConsultarPagosProveedorModalViewDetailsComponent implements OnInit {

  // Modales
  @ViewChild('verPago', { static: true }) modalVerPago: ModalDirective;

  // Form
  formHeader: FormGroup

  // Data & Tmp
  public rutEmpresa: number
  public sucursalCodigo: number
  public rutRecaudador: any
  public nombreRecaudador: any
  loading: boolean = false
  pago: any = null

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private messageRendererService: MessageRendererService,
    private clog: ConsoleService,
    private toastService: ToastService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private rutService: RutService,
    private pagoService: PagoService
  ) {
    this.log = this.clog.log('CONSULTAR-PAGOS-PROVEEDOR-DETAILS')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());

    this.createForms();
    this.formChangesSubscriptions()
  }

  private createForms() {
    // this.formHeader = this.fb.group({
    //   fecha_desde: [initDate, [Validators.required]],
    //   fecha_hasta: [currentDate, [Validators.required]],
    //   rutCliente: [null, []],
    //   codigo: [null, [Validators.required]],
    // });
  }

  private formChangesSubscriptions() {
    // this.formHeader.get("rutCliente").valueChanges
    //   .pipe(filter(Boolean), debounceTime(1000))
    //   .subscribe((rutCliente: string) => {
    //     this.modalSeleccionarCliente.searchByRut(rutCliente)
    //   })
  }

  loadAndShow(codigo: number, cliente_proveedor_rut: number) {
    this.cleanup()
    this.modalVerPago.show()
    this.buscar(codigo, cliente_proveedor_rut)
  }

  cleanup() {
    this.loading = true
    this.pago = null
  }

  buscar(codigo: number,cliente_proveedor_rut: number) {
    // this.formValidatorsService.validateAllFormFields(this.formHeader)
    // if (!this.formHeader.valid)
    //   return

    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        cliente_proveedor_rut,
        codigo
      }
    }

    this.log('inputParams', JSON.stringify(inputParams))

    this.loading = true
    this.pagoService.obtenerPagoProveedorEspecifico(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        this.loading = false
        return
      }

      this.pago = respuesta

      this.pago.saldoDocumento.forEach(pago => {
        pago.abono = 0
      })
      this.pago.canjeDocumento.forEach(pago => {
        pago.pagoAUtilizar = 0
      })
      this.rutRecaudador = this.rutService.AgregarDV(this.pago.rut_recaudador)
      this.nombreRecaudador = this.pago.nombre_recaudador

      // this.listaMovimientos.forEach(p => {
      //   p.rutFormato = this.rutService.AgregarDV(p.cliente_proveedor_rut)
      // })

      this.calcularTotales()
      this.loading = false
    })
  }

  calcularTotales() {
    this.pago.totales = {
      saldoDocumento: {
        monto: _.sumBy(this.pago.saldoDocumento, 'monto'),
        pago: _.sumBy(this.pago.saldoDocumento, 'pago'),
        abono: _.sumBy(this.pago.saldoDocumento, 'abono'),
        saldo: _.sumBy(this.pago.saldoDocumento, 'saldo'),
      },
      // difereciaPago:
      // {
      //   saldo: _.sumBy(this.pago.difereciaPago, 'saldo'),
      //   // pagoAUtilizar: _.sumBy(this.pago.difereciaPago, 'pagoAUtilizar'),
      // },
      forma_pago: _.sumBy(this.pago.forma_pago, 'monto'),
    }
  }

}
